export const type = ["SCPI de rendement", "SCPI de plus-value"];
export const category = [
  "Bureau",
  "Diversifiée",
  "Logistique",
  "Commerce",
  "Spécialisée",
  "Internationale",
  "Immobilier résidentiel",
  "SCPI d'entreprise à capital variable",
];

export const localisation = [
  "Paris",
  "Ile de France",
  "Régions",
  "Zone Euro",
  "Hors Zone Euro",
];
 
export const capitalType = [
  "fixe",
  "variable"
]
 
